<script lang="jsx">
import { config } from '@/lib/helpers'
import { mapActions, mapGetters } from 'vuex'
import { caseOf } from '../lib'

export default {
  setup() {
    return {}
  },
  computed: {
    ...mapGetters('dashbord', ['statsMarket']),

    invalidCredentials() {
      return caseOf(this.status, {
        _: () => false,
        Error: () => true,
      })
    },
  },
  created() {
    this.init()
  },
  methods: {
    ...mapActions('dashbord', ['init']),
  },
  render() {
    return (
      <div class="page">
        <h2>Manage</h2>
        <div class="card">
          <router-link to="/stores">
            <store-icon />
            <div>
              <h3>Manage Advertisers</h3>
              <p>Find and update advertiser or create a new one.</p>
            </div>
            <div class="">
              <chevron-right-icon />
            </div>
          </router-link>
        </div>

        <div class="card">
          <a href={`${config.adminV2Url}/clients`}>
            <clients-icon />
            <div>
              <h3>Manage Clients</h3>
              <p>Manage clients and payment tiers</p>
            </div>
            <div class="">
              <chevron-right-icon />
            </div>
          </a>
        </div>
        <div class="card">
          <a href={`${config.adminV2Url}/creators`}>
            <users-icon />
            <div>
              <h3>Manage Creators</h3>
              <p>Find creators and create custom links or view their stats</p>
            </div>
            <div className="">
              <chevron-right-icon />
            </div>
          </a>
        </div>

        <div class="card">
          <a
            href="https://app.powerbi.com/Redirect?action=OpenApp&appId=06e381d4-a9a4-47dd-8d0b-642199c860e5&ctid=94ce7d47-320c-4014-b5d7-40a42f741c3d"
            target="_blank"
          >
            <stats-icon />
            <div>
              <h3>View Statistics</h3>
              <p>Analyze user data in adapt</p>
            </div>
            <div class="">
              <chevron-right-icon />
            </div>
          </a>
        </div>
        <div class="card">
          <a href={`${config.adminV2Url}/content-library`}>
            <svg style="stroke: black; stroke-width: 4px;" class="icon">
              <use xlinkHref="#icon-instagram" />
            </svg>
            <div>
              <h3>View Content Library</h3>
              <p>See what our users post about on social media</p>
            </div>
            <div class="">
              <chevron-right-icon />
            </div>
          </a>
        </div>
        <div class="card">
          <router-link to="/payments">
            <svg class="icon">
              <use xlinkHref="#icon-dollar-sign" />
            </svg>
            <div>
              <h3>Manage Payments</h3>
              <p>View and create payments</p>
            </div>
            <div class="">
              <chevron-right-icon />
            </div>
          </router-link>
        </div>
      </div>
    )
  },
}
</script>
